export default __webpack_public_path__ + "static/media/sub-topic-model-07.466ec7de.glb";